
/**
 * 
 * @param {*} quizAccessShortId 
 * @param {*} authParams 
 * @returns 
 */

async function quizJoin(quizAccessShortId, authParams) {

	const joinUrl = "/api/quiz/" + quizAccessShortId + "/join"
	const httpResponse = await fetch(joinUrl, { 
		body: JSON.stringify({ auth: authParams }),
		headers: { "Content-Type": "application/json" },
		method: "POST"
	});

	const json = await httpResponse.json();
	return json;
}

/**
 * 
 * @param {String} quizParticipantId 
 * @param {*} quizAnswerData 
 * @returns 
 */
async function quizInstanceAnswerSave(quizParticipantId, quizAnswerData) {

	const httpResponse = await fetch("/api/quiz/instanceAnswerSave", { 
		body: JSON.stringify({ quizParticipantId, quizAnswerData }),
		headers: { "Content-Type": "application/json" },
		method: "POST"
	});

	const json = await httpResponse.json();
	return json;
}

/**
 * 
 * @param {*} quizAccessShortId 
 * @returns 
 */
async function quizAdminGetInfo(quizAccessShortId) {

	const url = `/api/quiz/${quizAccessShortId}/quizInfo`;
	const httpResponse = await fetch(url);

	const json = await httpResponse.json();
	return json;
}

/**
 * 
 * @param {*} quizAccessShortId 
 * @param {*} after 
 * @returns 
 */
async function quizAdminGetAnswerList(quizAccessShortId, after = 0) {

	const url = `/api/quiz/${quizAccessShortId}/answerList?after=${after}`;
	const httpResponse = await fetch(url);

	const json = await httpResponse.json();
	return json;
}

/**
 * 
 * @param {*} quizAccessId 
 * @returns 
 */
async function quizAdminGetStats(quizAccessId) {

	const url = `/api/quiz/${quizAccessId}/stats`;
	const httpResponse = await fetch(url);

	const json = await httpResponse.json();
	return json;
}

/**
 * 
 * @param {*} quizAccessId 
 * @returns 
 */
async function quizGetStats(quizAccessId) {

	const url = `/api/quiz/${quizAccessId}/stats`;
	const httpResponse = await fetch(url);

	const json = await httpResponse.json();
	return json;
}

/**
 * Starts a quiz instance.
 * 
 * @param {String} quizInstanceId 
 * @returns 
 */
async function quizInstanceStart(quizInstanceId, roomMode = false, standingMode = false) {

	const httpResponse = await fetch("/api/quiz/instanceStart", {
		body: JSON.stringify({ quizInstanceId, roomMode, standingMode }),
		headers: { "Content-Type": "application/json" },
		method: "POST"
	});

	const json = await httpResponse.json();
	return json;
}

async function quizInstanceRoomModeSetQuestion(quizInstanceId, questionIndex) {

	const httpResponse = await fetch("/api/quiz/instanceRoomModeSetQuestion", {
		body: JSON.stringify({ quizInstanceId, questionIndex }),
		headers: { "Content-Type": "application/json" },
		method: "POST"
	});

	const json = await httpResponse.json();
	return json;
}

/**
 * Ends a quiz instance.
 * 
 * @param {String} quizInstanceId 
 * @returns 
 */
async function quizInstanceEnd(quizInstanceId) {

	const httpResponse = await fetch("/api/quiz/instanceEnd", { 
		body: JSON.stringify({ quizInstanceId }),
		headers: { "Content-Type": "application/json" },
		method: "POST"
	});

	const json = await httpResponse.json();
	return json;
}

/**
 * 
 * @returns 
 */
async function userSessionGet() {

	const url = `/api/user/session`;
	const httpResponse = await fetch(url);

	const json = await httpResponse.json();
	return json;
}

/**
 * 
 * @param {String} username 
 * @param {String} password 
 * @returns 
 */
async function userLogin(username, password) {

	const httpResponse = await fetch("/api/login", { 
		body: JSON.stringify({ username, password }),
		headers: { "Content-Type": "application/json" },
		method: "POST"
	});

	const json = await httpResponse.json();
	return json;
}

/**
 * Logs out the current user
 * 
 * @returns 
 */
async function userLogout() {

	const httpResponse = await fetch("/api/logout", { 
		method: "POST"
	});

	const json = await httpResponse.json();
	return json;
}

/**
 * 
 * @returns 
 */
async function userQuizListGet() {

	const url = `/api/quizList`;
	const httpResponse = await fetch(url);

	const json = await httpResponse.json();
	return json;
}

/**
 * 
 * @returns 
 */
async function userQuizInstanceListGet(quizId) {

	const url = `/api/quiz/${quizId}/instances`;
	const httpResponse = await fetch(url);

	const json = await httpResponse.json();
	return json;
}


/**
 * 
 * @param {*} quizId 
 * @returns 
 */
async function quizInstanceCreate(quizId) {

	const url = `/api/quiz/${quizId}/createInstance`;
	const httpResponse = await fetch(url, { 
		headers: { "Content-Type": "application/json" },
		method: "POST"
	});

	const json = await httpResponse.json();
	return json;
}

/**
 * 
 * @param {String} quizId 
 * @returns 
 */
async function quizLiveInstanceCreate(quizId) {

	const url = `/api/quiz/${quizId}/liveInstance`;
	const httpResponse = await fetch(url, { 
		headers: { "Content-Type": "application/json" },
		method: "POST"
	});

	const json = await httpResponse.json();
	return json;
}

/**
 * Creates a new quiz.
 * 
 * @param {String} quizName 
 * @param {Number} quizDuration 
 * @param {String} quizType 
 * @param {Object} quizConfig 
 * @param {File} quizGenFile 
 * @returns 
 */
async function quizCreate(quizName, quizDuration, quizType, quizConfig, quizGenFile = null, quizGroupId = null) {

	const formData = new FormData();
	formData.append("quizName", quizName);
	formData.append("quizType", quizType);
	formData.append("quizDuration", quizDuration);
	formData.append("quizConfig", JSON.stringify(quizConfig));

	if (quizGenFile) {
		formData.append("quizGenFile", quizGenFile, quizGenFile.name);
	}
	if (quizGroupId) {
		formData.append("quizGroupId", quizGroupId);
	}

	const httpResponse = await fetch(`/api/quizCreate`, {
		body: formData,
		method: "POST"
	});

	const json = await httpResponse.json();
	return json;
}

async function quizGroupList() {
	const httpResponse = await fetch(`/api/quizGroups`);
	const json = await httpResponse.json();
	return json;
}

async function quizGroupCreate(groupName) {
	const httpResponse = await fetch(`/api/quizGroupCreate`, {
		headers: { "Content-Type": "application/json" },
		body: JSON.stringify({ groupName }),
		method: "POST"
	});
	const json = await httpResponse.json();
	return json;
}

async function courseSessionCreate(quizGroupId) {
	const httpResponse = await fetch(`/api/courseSessionCreate`, {
		headers: { "Content-Type": "application/json" },
		body: JSON.stringify({ quizGroupId }),
		method: "POST"
	});
	const json = await httpResponse.json();
	return json;
}

async function courseSessionJoin(courseSessionShortId, alias) {
	const httpResponse = await fetch(`/api/courseSession/${courseSessionShortId}/join`, {
		headers: { "Content-Type": "application/json" },
		body: JSON.stringify({ alias }),
		method: "POST"
	});
	const json = await httpResponse.json();
	return json;
}

async function courseSessionEnd(courseSessionId) {
	const httpResponse = await fetch(`/api/courseSessionEnd`, {
		headers: { "Content-Type": "application/json" },
		body: JSON.stringify({ courseSessionId }),
		method: "POST"
	});
	const json = await httpResponse.json();
	return json;
}

async function courseSessionActiveList() {
	const httpResponse = await fetch(`/api/courseSessionActiveList`);
	const json = await httpResponse.json();
	return json;
}

async function quizInstanceDelete(instanceId) {
	const httpResponse = await fetch(`/api/quiz/instance/${instanceId}/delete`, {
		method: "POST"
	});
	const json = await httpResponse.json();
	return json;
}

async function quizSimulate(quizId, participantCount) {
	const httpResponse = await fetch(`/api/quiz/${quizId}/simulate`, {
		headers: { "Content-Type": "application/json" },
		body: JSON.stringify({ participantCount }),
		method: "POST"
	});
	const json = await httpResponse.json();
	return json;
}

/**
 * 
 * @param {*} quizId 
 * @param {*} quizName 
 * @param {*} quizDuration 
 * @param {*} quizConfig 
 * @returns 
 */
async function quizEdit(quizId, quizName, quizDuration, quizConfig, quizGroupId = undefined) {

	const httpResponse = await fetch(`/api/quiz/${quizId}/edit`, {
		headers: { "Content-Type": "application/json" },
		body: JSON.stringify({
			quizName, quizDuration, quizConfig,
			...(quizGroupId !== undefined ? { quizGroupId } : {})
		}),
		method: "POST"
	});

	const json = await httpResponse.json();
	return json;
}

/**
 * Starts a background job that generates a batch of Musicquiz questions
 * from Deezer, based on a genre/theme (and optionally a year range).
 *
 * @param {String} quizId
 * @param {Object} params { theme, yearFrom, yearTo, count, mode }
 * @returns
 */
async function quizMusicBulkGenerate(quizId, { theme, yearFrom, yearTo, count, mode, inputMode }) {

	const httpResponse = await fetch(`/api/quiz/${quizId}/musicBulkGenerate`, {
		headers: { "Content-Type": "application/json" },
		body: JSON.stringify({ theme, yearFrom, yearTo, count, mode, inputMode }),
		method: "POST"
	});

	const json = await httpResponse.json();
	return json;
}

/**
 * Deletes a quiz.
 *
 * @param {String} quizId
 * @returns
 */
async function quizDelete(quizId) {

	const httpResponse = await fetch(`/api/quiz/${quizId}`, {
		method: "DELETE"
	});

	const json = await httpResponse.json();
	return json;
}

async function quizClone(quizId) {

	const httpResponse = await fetch(`/api/quiz/${quizId}/clone`, {
		method: "POST"
	});

	const json = await httpResponse.json();
	return json;
}

/**
 * 
 * @returns 
 */
async function quizDetails(quizId) {

	const url = `/api/quiz/${quizId}/details`;
	const httpResponse = await fetch(url);

	const json = await httpResponse.json();
	return json;
}

/**
 * Fetches a single quiz question
 * 
 * @param {String} quizId 
 * @param {String} quizQuestionId 
 * @returns 
 */
async function quizQuestionGet(quizId, quizQuestionId) {

	const url = `/api/quiz/${quizId}/question/${quizQuestionId}`;
	const httpResponse = await fetch(url);

	const json = await httpResponse.json();
	return json;
}

/**
 * Updates the order of the quiz questions.
 * 
 * @param {String} quizId Quiz id
 * @param {Array} questionIdList Ordered question id list
 * @returns Parsed response JSON
 */
async function quizQuestionOrderUpdate(quizId, questionIdList) {

	const url = `/api/quiz/${quizId}/questionOrderUpdate`;
	const httpResponse = await fetch(url, { 
		body: JSON.stringify({ questionIdList }),
		headers: { "Content-Type": "application/json" },
		method: "POST"
	});

	const json = await httpResponse.json();
	return json;
}

/**
 * Deletes a question
 * 
 * @param {String} quizId 
 * @param {String} questionId 
 * @returns 
 */
async function quizQuestionDelete(quizId, questionId) {

	const url = `/api/quiz/${quizId}/question/${questionId}`;
	const httpResponse = await fetch(url, { 
		method: "DELETE"
	});

	const json = await httpResponse.json();
	return json;
}

async function orgSettingsGet() {
	const r = await fetch('/api/org/settings');
	return r.json();
}

async function orgSetBackgroundColor(backgroundCss) {
	const r = await fetch('/api/org/setBackgroundColor', {
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		body: JSON.stringify({ backgroundCss })
	});
	return r.json();
}

async function orgSetLogo(file) {
	const form = new FormData();
	form.append('logo', file);
	const r = await fetch('/api/org/setLogo', { method: 'POST', body: form });
	return r.json();
}

async function orgRemoveLogo() {
	const r = await fetch('/api/org/removeLogo', { method: 'POST' });
	return r.json();
}

async function orgUserCreate(userName, userEmail, fullName) {
	const r = await fetch('/api/org/userCreate', {
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		body: JSON.stringify({ userName, userEmail, fullName })
	});
	return r.json();
}

async function orgUserDelete(userRandom) {
	const r = await fetch(`/api/org/user/${userRandom}/delete`, { method: 'POST' });
	return r.json();
}

async function orgChangePassword(currentPassword, newPassword) {
	const r = await fetch('/api/org/changePassword', {
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		body: JSON.stringify({ currentPassword, newPassword })
	});
	return r.json();
}

async function orgInviteUserCreate(email) {
	const r = await fetch('/api/org/inviteUser', {
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		body: JSON.stringify({ email })
	});
	return r.json();
}

async function orgInviteRevoke(inviteId) {
	const r = await fetch(`/api/org/invite/${inviteId}/revoke`, { method: 'POST' });
	return r.json();
}

// ── Cross-org superadmin (SUPER_USER only) ─────────────────────────

async function superOrganizationListGet() {
	const r = await fetch('/api/admin/organizations');
	return r.json();
}

async function superOrganizationDetailsGet(organizationId) {
	const r = await fetch(`/api/admin/organization/${organizationId}/details`);
	return r.json();
}

async function superOrganizationUserSetPremium(organizationId, userRandom) {
	const r = await fetch(`/api/admin/organization/${organizationId}/user/${userRandom}/setPremium`, { method: 'POST' });
	return r.json();
}

/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default {

	quizCreate,
	quizClone,
	quizDelete,
	quizDetails,
	quizEdit,
	quizGroupList,
	quizGroupCreate,
	courseSessionCreate,
	courseSessionJoin,
	courseSessionEnd,
	courseSessionActiveList,
	quizSimulate,
	quizInstanceDelete,
	quizJoin,
	
	quizInstanceCreate,
	quizInstanceStart,
	quizInstanceEnd,
	quizInstanceRoomModeSetQuestion,
	quizInstanceAnswerSave,

	quizLiveInstanceCreate,

	quizAdminGetInfo,
	quizAdminGetStats,
	quizAdminGetAnswerList,

	quizGetStats,
	userQuizListGet,
	userQuizInstanceListGet,

	userSessionGet,
	userLogin,
	userLogout,

	quizQuestionGet,
	quizQuestionOrderUpdate,
	quizQuestionDelete,
	quizMusicBulkGenerate,

	// ── Org settings (SUPER_USER only) ──────────────────────────────
	orgSettingsGet,
	orgSetBackgroundColor,
	orgSetLogo,
	orgRemoveLogo,
	orgUserCreate,
	orgUserDelete,
	orgChangePassword,
	orgInviteUserCreate,
	orgInviteRevoke,

	// ── Cross-org superadmin (SUPER_USER only) ───────────────────────
	superOrganizationListGet,
	superOrganizationDetailsGet,
	superOrganizationUserSetPremium
}